import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';

@Metamodel.model({
    name: 'OracleFusion',
    display: []
})
export class OracleFusionLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
}
